<template>
  <div id="app">
    <Home />
  </div>
</template>

<script>
import Home from './components/Home.vue'

export default {
  name: 'App',
  components: {
    Home
  }
}
</script>

<style lang="scss">
*{
  margin:0;
  padding:0;
  box-sizing: border-box;
}

body{
  background: #000;
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: normal;
  font-size: 17px;
  line-height: 174.2%;
  color: #FFFFFF;
}
</style>
